export default __webpack_public_path__ + "static/media/Guide.143e3b03.JPG";